<div id="progress-container">
    <progress #progressBar value="0" max="100"></progress>
    <span id="progress-text">{{ progressText }}</span>
  </div>
  <video #video controls autoplay muted>
    <source type="video/mp4">
    Your browser does not support the video tag.
  </video>
  